import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { createBrowsingHistoryService } from '../application/services/BrowsingHistoryService';
import { BrowsingHistoryAdapter } from '../infra/adapters/browsingHistory.adapter';

export function browsingHistoryBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new BrowsingHistoryAdapter(d),
    (repo) => createBrowsingHistoryService(repo),
    dispatch,
  );
}
